export const useBreakpoints = () => {
    return {
        extraSmall: 650,
        small:  700,
        medium: 800,
        large: 1024
    }
}